import { render, staticRenderFns } from "./UpdateContact.vue?vue&type=template&id=5b4fe244&scoped=true&"
import script from "./UpdateContact.vue?vue&type=script&lang=js&"
export * from "./UpdateContact.vue?vue&type=script&lang=js&"
import style0 from "./UpdateContact.vue?vue&type=style&index=0&id=5b4fe244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fe244",
  null
  
)

export default component.exports